module.exports = __webpack_public_path__ + "assets/img/modal-avatar-b8c50b40.png";